import { isNil } from 'lodash-es';

import { ISanityItemOption, ISanityItemOptionModifier } from '@rbi-ctg/menu';

import { onlyDefaultModifierIsAvailable } from './only-default-modifier-is-available';

import { and, compose, get, minLengthWithDefaultValue, not } from '..';

export const shouldDisplayItemOption = compose<
  [ISanityItemOption],
  ISanityItemOptionModifier[],
  boolean
>(
  and(not(isNil), and(minLengthWithDefaultValue(1, []), not(onlyDefaultModifierIsAvailable))),
  get('options')
);
